<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" style="background: #f5f5f5" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="6">
            <div class="text-center mb-5">
              <img :src="logo" alt="Logo" width="150" />
            </div>

            <v-card class="elevation-2 pa-5" style="border-radius: 25px" :disabled="loading">
              <v-card-text class="mt-5">
                <h2 class="text-center grey--text text--darken-3">Recuperar senha</h2>
                <h4 class="text-center grey--text text--darken-3 mt-3">Para recuperar sua senha informe seu e-mail</h4>

                <v-row align="center" justify="center" class="mt-5">
                  <v-col cols="12" sm="12" md="10">
                    <v-form ref="form" @submit.prevent="recovery()">
                      <v-text-field
                        v-model="form.email"
                        label="Email"
                        type="email"
                        prepend-icon="mdi-email"
                        class="mt-2"
                        :rules="[rules.required,rules.email]"
                        autofocus
                      />

                      <div class="text-center">
                        <div class="mt-5">
                          <v-btn
                            color="red"
                            rounded
                            dark
                            large
                            style="width: 220px"
                            type="submit"
                            :loading="loading"
                          >
                            <v-icon left>mdi-lock</v-icon>
                            RECUPERAR SENHA
                          </v-btn>
                        </div>

                        <div class="mt-10" style="font-size: 12pt">
                          <router-link :to="'/login'">Clique aqui para voltar ao login!</router-link>
                        </div>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import rules from '@/utils/rules'
import Auth from '@/services/auth'

export default {
  name: 'Recovery',

  data() {
    return {
      loading: false,
      logo: "/img/Logo.png",
      rules: rules,

      form: {
        email: ''
      }
    }
  },

  methods: {
    async recovery() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      try{
        const result = await new Auth().recoveryPasswd(this.form.email)
        this.$swal.success('', result)
        this.$router.push("/login")
      } catch (error) {
        console.error(error)
        this.$swal.error('', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
